import React, { useEffect, useState } from 'react';
import { useSearchParams, useParams } from 'react-router-dom';
import axios from 'axios';
import { EMILIA_LOGO_B64 } from '../transport/quotes/emilia_logo_b64';

const API_BASE = process.env.REACT_APP_API_URL || 'https://flujo-app-backend.onrender.com';

const PaymentSuccessPage = () => {
    const routeParams = useParams();
    const [searchParams] = useSearchParams();
    const tripId = routeParams.trip_id || searchParams.get('trip_id') || searchParams.get('tripId');
    const [receipt, setReceipt] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!tripId) {
            setLoading(false);
            return;
        }

        const fetchReceipt = async () => {
            try {
                const res = await axios.get(`${API_BASE}/transport/dlocal/receipt/${tripId}/`);
                setReceipt(res.data);
            } catch (err) {
                console.error("Error fetching payment receipt:", err);
                setError("No pudimos cargar los detalles del comprobante.");
            } finally {
                setLoading(false);
            }
        };

        fetchReceipt();
    }, [tripId]);

    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f4f6f9', padding: '30px 15px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
            <div style={{ maxWidth: '580px', margin: '0 auto' }}>
                
                {/* Cabecera con Logotipo de Transportes Emilia */}
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                    <img 
                        src={EMILIA_LOGO_B64} 
                        alt="Transportes Emilia" 
                        style={{ maxHeight: '75px', objectFit: 'contain', marginBottom: '8px' }} 
                    />
                    <div style={{ fontSize: '13px', color: '#6c757d', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '1px' }}>
                        Servicios Corporativos & Traslados Privados
                    </div>
                </div>

                {/* Tarjeta Principal de Comprobante */}
                <div style={{ 
                    backgroundColor: '#ffffff', 
                    borderRadius: '16px', 
                    boxShadow: '0 8px 30px rgba(0,0,0,0.08)', 
                    overflow: 'hidden',
                    border: '1px solid #e9ecef'
                }}>
                    {/* Header Verde de Aprobación */}
                    <div style={{ 
                        backgroundColor: '#198754', 
                        padding: '24px 20px', 
                        textAlign: 'center', 
                        color: '#ffffff' 
                    }}>
                        <div style={{
                            width: '64px',
                            height: '64px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 12px auto',
                            fontSize: '32px'
                        }}>
                            ✓
                        </div>
                        <h4 style={{ margin: 0, fontWeight: '700', fontSize: '22px' }}>
                            ¡Pago Realizado con Éxito!
                        </h4>
                        <p style={{ margin: '6px 0 0 0', opacity: 0.9, fontSize: '14px' }}>
                            Tu reserva ha sido confirmada y acreditada correctamente.
                        </p>
                    </div>

                    {/* Contenido del Recibo */}
                    <div style={{ padding: '24px 20px' }}>
                        {loading ? (
                            <div style={{ textAlign: 'center', padding: '40px 0', color: '#6c757d' }}>
                                <div className="spinner-border text-success" role="status" style={{ marginBottom: '12px' }}></div>
                                <div>Cargando detalle del comprobante...</div>
                            </div>
                        ) : error ? (
                            <div style={{ textAlign: 'center', padding: '20px', color: '#dc3545' }}>
                                <p style={{ fontWeight: '600' }}>{error}</p>
                                <p style={{ fontSize: '13px', color: '#6c757d' }}>
                                    Tu pago fue procesado en la pasarela. Puedes comunicarte con Transportes Emilia para reconfirmar tu servicio.
                                </p>
                                <a 
                                    href="https://www.transportesemilia.cl"
                                    style={{
                                        display: 'inline-block',
                                        marginTop: '12px',
                                        padding: '10px 20px',
                                        backgroundColor: '#0d6efd',
                                        color: '#ffffff',
                                        textDecoration: 'none',
                                        borderRadius: '8px',
                                        fontWeight: '600',
                                        fontSize: '13px'
                                    }}
                                >
                                    🌐 Ir a www.transportesemilia.cl
                                </a>
                            </div>
                        ) : !tripId ? (
                            <div style={{ textAlign: 'center', padding: '20px' }}>
                                <h5 style={{ fontWeight: '700', color: '#212529' }}>¡Gracias por tu pago!</h5>
                                <p style={{ fontSize: '14px', color: '#6c757d', marginTop: '8px' }}>
                                    Tu transacción fue recibida. Puedes visitar nuestro sitio web oficial o contactarnos directamente si necesitas asistencia con tu traslado.
                                </p>
                                <a 
                                    href="https://www.transportesemilia.cl"
                                    style={{
                                        display: 'inline-block',
                                        marginTop: '12px',
                                        padding: '12px 24px',
                                        backgroundColor: '#198754',
                                        color: '#ffffff',
                                        textDecoration: 'none',
                                        borderRadius: '10px',
                                        fontWeight: '600',
                                        fontSize: '14px'
                                    }}
                                >
                                    🌐 Ir a www.transportesemilia.cl
                                </a>
                            </div>
                        ) : (
                            <div>
                                <div style={{ 
                                    display: 'flex', 
                                    justifyContent: 'space-between', 
                                    alignItems: 'center', 
                                    paddingBottom: '16px', 
                                    borderBottom: '1px dashed #dee2e6',
                                    marginBottom: '16px' 
                                }}>
                                    <div>
                                        <div style={{ fontSize: '12px', color: '#6c757d' }}>
                                            {receipt?.is_multi ? `PAGO GRUPAL (${receipt.related_trips.length} SERVICIOS)` : 'Nº DE RESERVA'}
                                        </div>
                                        <div style={{ fontSize: '18px', fontWeight: '800', color: '#0d6efd' }}>
                                            {receipt?.is_multi 
                                                ? receipt.related_trips.map(r => `#${r.trip_id}`).join(', ')
                                                : `#${receipt?.trip_id || tripId}`}
                                        </div>
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        <div style={{ fontSize: '12px', color: '#6c757d' }}>TOTAL PAGADO</div>
                                        <div style={{ fontSize: '22px', fontWeight: '800', color: '#198754' }}>
                                            {receipt?.currency === 'USD' ? `US$ ${receipt?.amount}` : `$${Number(receipt?.amount || 0).toLocaleString('es-CL')} CLP`}
                                        </div>
                                    </div>
                                </div>

                                {/* Desglose si es pago grupal */}
                                {receipt?.is_multi && receipt?.related_trips && receipt.related_trips.length > 1 ? (
                                    <div style={{ marginBottom: '16px' }}>
                                        <div style={{ fontSize: '12px', fontWeight: '700', color: '#495057', marginBottom: '8px', textTransform: 'uppercase' }}>
                                            Detalle de Servicios Cubiertos:
                                        </div>
                                        <div style={{ backgroundColor: '#f8f9fa', borderRadius: '10px', padding: '8px', border: '1px solid #e9ecef' }}>
                                            {receipt.related_trips.map((rt, idx) => (
                                                <div 
                                                    key={rt.trip_id} 
                                                    style={{ 
                                                        padding: '8px', 
                                                        borderBottom: idx < receipt.related_trips.length - 1 ? '1px solid #dee2e6' : 'none',
                                                        fontSize: '13px'
                                                    }}
                                                >
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '600' }}>
                                                        <span style={{ color: '#0d6efd' }}>Reserva #{rt.trip_id}</span>
                                                        <span style={{ color: '#198754' }}>${Number(rt.amount || 0).toLocaleString('es-CL')} CLP</span>
                                                    </div>
                                                    <div style={{ color: '#6c757d', fontSize: '12px', marginTop: '2px' }}>
                                                        {rt.passenger_name} {rt.scheduled_time ? `• ${rt.scheduled_time}` : ''}
                                                    </div>
                                                    <div style={{ color: '#495057', fontSize: '11px', marginTop: '2px' }}>
                                                        📍 {rt.origin_address} ➔ {rt.destination_address}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ) : (
                                    /* Tabla de Atributos individual */
                                    <div style={{ fontSize: '14px', lineHeight: '1.6' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
                                            <span style={{ color: '#6c757d' }}>Pasajero:</span>
                                            <span style={{ fontWeight: '600', color: '#212529', textAlign: 'right' }}>{receipt?.passenger_name || 'Particular'}</span>
                                        </div>

                                        {receipt?.scheduled_time && (
                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
                                                <span style={{ color: '#6c757d' }}>Fecha y Hora:</span>
                                                <span style={{ fontWeight: '600', color: '#212529', textAlign: 'right' }}>{receipt.scheduled_time}</span>
                                            </div>
                                        )}

                                        {receipt?.origin_address && receipt.origin_address !== '---' && (
                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
                                                <span style={{ color: '#6c757d', minWidth: '80px' }}>Origen:</span>
                                                <span style={{ fontWeight: '500', color: '#495057', textAlign: 'right', fontSize: '13px' }}>{receipt.origin_address}</span>
                                            </div>
                                        )}

                                        {receipt?.destination_address && receipt.destination_address !== '---' && (
                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0' }}>
                                                <span style={{ color: '#6c757d', minWidth: '80px' }}>Destino:</span>
                                                <span style={{ fontWeight: '500', color: '#495057', textAlign: 'right', fontSize: '13px' }}>{receipt.destination_address}</span>
                                            </div>
                                        )}
                                    </div>
                                )}

                                <div style={{ fontSize: '14px', lineHeight: '1.6', marginTop: '8px', borderTop: '1px solid #f1f3f5', paddingTop: '8px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                                        <span style={{ color: '#6c757d' }}>Método de Pago:</span>
                                        <span style={{ fontWeight: '600', color: '#198754' }}>
                                            {String(receipt?.payment_method || '').toLowerCase() === 'webpay' || searchParams.get('provider') === 'webpay'
                                                ? 'Tarjeta (Webpay Plus - Transbank)'
                                                : 'Tarjeta (dLocal Go)'}
                                        </span>
                                    </div>

                                    {receipt?.payment_auth_code && (
                                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                                            <span style={{ color: '#6c757d' }}>
                                                {String(receipt?.payment_method || '').toLowerCase() === 'webpay' || searchParams.get('provider') === 'webpay'
                                                    ? 'Cód. Autorización:'
                                                    : 'ID Transacción:'}
                                            </span>
                                            <span style={{ fontFamily: 'monospace', fontSize: '12px', color: '#6c757d', fontWeight: '600' }}>{receipt.payment_auth_code}</span>
                                        </div>
                                    )}
                                </div>

                                {/* Cuadro de Información Informativa */}
                                <div style={{ 
                                    marginTop: '20px', 
                                    padding: '12px 16px', 
                                    backgroundColor: '#e8f5e9', 
                                    borderRadius: '10px', 
                                    border: '1px solid #c8e6c9',
                                    fontSize: '13px',
                                    color: '#2e7d32'
                                }}>
                                    ✓ <strong>Servicio confirmado:</strong> Nuestro equipo de despacho y chofer asignado cuentan con la información de tu traslado. Ante cualquier duda, contáctanos directamente.
                                </div>
                            </div>
                        )}

                        {/* Botones de Acción */}
                        <div style={{ marginTop: '24px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <button 
                                onClick={() => window.print()}
                                style={{
                                    width: '100%',
                                    padding: '12px',
                                    backgroundColor: '#0d6efd',
                                    color: '#ffffff',
                                    border: 'none',
                                    borderRadius: '10px',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    cursor: 'pointer'
                                }}
                            >
                                🖨️ Imprimir / Guardar Comprobante
                            </button>
                            <a 
                                href="https://www.transportesemilia.cl"
                                style={{
                                    display: 'block',
                                    textAlign: 'center',
                                    padding: '12px',
                                    backgroundColor: '#212529',
                                    color: '#ffffff',
                                    textDecoration: 'none',
                                    borderRadius: '10px',
                                    fontWeight: '600',
                                    fontSize: '14px'
                                }}
                            >
                                🌐 Ir al sitio web www.transportesemilia.cl
                            </a>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '12px', color: '#adb5bd' }}>
                    © {new Date().getFullYear()} Transportes Emilia SpA. Todos los derechos reservados.
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccessPage;
